import { QueryClient } from "@tanstack/react-query";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";

export async function utahOnboardingSelfIdentificationLoader(queryClient: QueryClient) {
  try {
    const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());

    // prefetch demographics data
    await queryClient.ensureQueryData(USERS_QUERIES.demographics(user.id.toString()));
    return null;
  } catch (_error) {
    return null;
  }
}
